<template>
  <div>
    <div class="d-flex justify-content-between mb-2">
      <div class="d-flex align-items-center" style="gap:10px">
        <div class="section-title">
          {{ $tc("distributor", 1) }} {{ $t("contract") }}
        </div>

        <div class="">
          <div class="dropdown-curve-container" style="width:200px">
            <div class="d-flex align-items-center">
              <!--label :class="this.selectedCineId ? 'shift-up' : ''">
              {{ $t("Select") }}
              {{ $tc("Cinema") }}
            </label--->
              <multiselect
                :multiple="true"
                placeholder="Select Cinema"
                :group-select="false"
                select-label="Select"
                label="cine_name"
                :options="cinemasName"
                deselect-label="Remove"
                track-by="cine_id"
                @select="onSelectCinema($event, cinema.cine_id)"
                @remove="onRemoveCinema($event, cinema.cine_id)"
                v-model="selectedCineIdObj"
              ></multiselect>
            </div>
          </div>
        </div>
        <!-- v-for="(cinema, cinemaIndex) in cinemasName"-->
      </div>
      <!-- <div>
        <b-button
          v-if="!flag.isDistributor"
          variant="default"
          to="add-distributor-contract"
          class="btn-blue"
        >{{ $tc('add') }}</b-button>
      </div> -->
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="
            filterIsActive => {
              this.getDistributorContract(filterIsActive);
            }
          "
        />
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <!-- <div class="viewing-status">
          {{ $t('viewing')}}
          <span>1-20</span>of
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
        </div>-->
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <table class="list-view-table" v-if="listView">
      <thead class="text-center">
        <tr>
          <th class="text-left" style="width:100px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>

          <th style="width:355px" class="text-center">
            <img
              v-if="this.columnName != 'd_company_name'"
              @click="onSortValue('d_company_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('d_company_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('d_company_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("distributor", 1) }}
          </th>
          <th class="text-center" style="width:310px">
            <img
              v-if="this.columnName != 'movie_title'"
              @click="onSortValue('movie_title', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('movie_title', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('movie_title', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("movie", 1) }}
          </th>
          <th class="text-center" style="width:120px">
            <img
              v-if="this.columnName != 'cine_name'"
              @click="onSortValue('cine_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('cine_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('cine_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("cinema", 1) }}
          </th>
          <th class="text-center">{{ $tc("weekwiseContract", 1) }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(distributorgetContract,
          distributorgetContractIndex) in distributorgetContractList"
          :key="distributorgetContractIndex"
          class="light_grey_back"
        >
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <!-- <b-form-checkbox
                v-model="distributorgetContract.dc_is_active"
                unchecked-value="N"
                value="Y"
                name="check-button"
                switch
                disabled
              ></b-form-checkbox> -->
              <StatusDot
                :status="
                  distributorgetContract.dc_is_active === 'Y'
                    ? 'active'
                    : distributorgetContract.dc_is_active === 'N' && 'inactive'
                "
              />

              <b-dropdown right variant="edit" class="ml-2">
                <b-dropdown-item
                  v-if="!flag.isDistributor"
                  @click="
                    goToRoute(
                      '/distributor/edit-distributor-contract',
                      distributorgetContract
                    )
                  "
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="
                    goToRoute(
                      '/distributor/view-distributor-contract',
                      distributorgetContract
                    )
                  "
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>

          <td>{{ distributorgetContract.d_company_name }}</td>
          <td class="text-left">
            {{
              distributorgetContract.movie_name ||
                distributorgetContract.movie_title
            }}
          </td>
          <td class="text-left">{{ distributorgetContract.cine_name }}</td>
          <td class="text-left">
            {{ distributorgetContract.contract_weekwise_name }}
          </td>
        </tr>
        <tr v-if="distributorgetContractList.length == 0">
          <td colspan="5">
            <!-- <h5 class="text-center">{{ $t("NoRecords") }}</h5> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="distributorgetContractList.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(distributorgetContract,
        distributorgetContractIndex) in distributorgetContractList"
        :key="distributorgetContractIndex"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ distributorgetContract.d_company_name }}</h6>
            <h4>{{ distributorgetContract.cine_name }}</h4>
            <h4>{{ distributorgetContract.movie_title }}</h4>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="!flag.isDistributor"
                  @click="
                    goToRoute(
                      '/distributor/edit-distributor-contract',
                      distributorgetContract
                    )
                  "
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="
                    goToRoute(
                      '/distributor/view-distributor-contract',
                      distributorgetContract
                    )
                  "
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <!-- <div class="count">059</div> -->
              <div class="text">{{ distributorgetContract.cine_name }}</div>
            </div>
            <div class="d-flex align-items-end">
              <div class="col-4">
                <!-- <b-form-checkbox
                  v-model="distributorgetContract.dc_is_active"
                  unchecked-value="N"
                  value="Y"
                  name="check-button"
                  switch
                ></b-form-checkbox> -->
                <StatusDot
                  :status="
                    distributorgetContract.dc_is_active === 'Y'
                      ? 'active'
                      : distributorgetContract.dc_is_active === 'N' &&
                        'inactive'
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="distributorgetContractList.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import DistributorService from "@/services/DistributorService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import MasterService from "@/services/MasterService";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      cinema_id: null,
      // Saif
      distributorgetContractList: [],

      distributorShareType: {
        dst_label: "",
        dst_fixed_value_to_theatre: "Y",
        dst_percentage_of: "Net Amount",
        dst_is_percentage: "Y",
        dst_duration: "Weekly",
        dst_is_active: "Y"
      },
      flag: {
        isDistributor: false
      },
      // Saif
      gridView: false,
      listView: true,

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
      searchValue: "",
      selectedCineId: "",
      selectedCineIdObj: "",
      cinemasName: []
    };
  },
  beforeMount() {
    this.cinema_id = this.secureStore.get("USINFO").cinema_id;
    this.getCinemasList(this.cinema_id);
    this.getviewingnumber();
    this.getDistributorContract();
    if (
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO").role_name &&
      this.secureStore.get("USINFO").role_name === "Distributor"
    ) {
      this.flag.isDistributor = true;
    }
  },
  mounted() {},
  methods: {
    onSelectCinema(event, cinema) {
      this.selectedCineId = event.cine_id;
      this.getDistributorContract();
    },
    onRemoveCinema(event, cinema) {
      this.selectedCineId = "";
      this.getDistributorContract();
    },
    getCinemasList: function(cine_id) {
      this.cinemasName = [];
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemasName = data.Records;
            // this.CinemasCopy = data.Records;
            console.log("this.Cinemas :", this.cinemasName);
            // this.Cinemas.map(x => {
            //   if (String(cine_id) === String(x.cine_id)) {
            //     this.selectedCinema = x.cine_name;
            //     let cine_id = x.cine_id;
            //     this.getConcessionList(cine_id);
            //   }
            // });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getDistributorContract();
      } else {
        this.currentPage = event;
        this.getDistributorContract();
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getDistributorContract();
    },
    // Saif
    getDistributorContract: function(filter_is_active = "Y") {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        cinema_id: this.selectedCineId ? this.selectedCineId : "",
        searchValue: this.searchValue,
        filter_is_active: filter_is_active
      };
      DistributorService.GetDistributorContract(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.distributorgetContractList = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.distributorgetContractList = [];
              this.rows = 0;
              this.selectedvalue = 0;
            }
          } else {
            // Show Error Message
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch Error on getDistributorShareType :", error);
        });
    },
    goToRoute: function(path, { dc_id }) {
      this.$router.push({
        path: path,
        query: {
          id: dc_id
        }
      });
    },
    // Saif

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
    // onClickEdit: function(){
    //   this.$router.push({ path: 'master/editaggregators' })
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorContractComponents/distributorContract.vue